import {
    faArrowsSpin,
    faBan,
    faBuildings,
    faCogs,
    faCommand,
    faCreditCard,
    faEnvelope,
    faEnvelopesBulk,
    faGlobe,
    faLanguage,
    faMoneyBill,
    faPenField,
    faShield,
    faUser,
    faUsers,
} from "@fortawesome/pro-regular-svg-icons";
import { faMapLocation } from "@fortawesome/pro-light-svg-icons";
import { faBolt } from "@fortawesome/pro-solid-svg-icons";
import { library } from "@fortawesome/fontawesome-svg-core";

// Adding the icons that are used in the navigation here will avoid tree-shaking them away
library.add(faCogs, faMoneyBill, faUser, faBuildings, faUsers, faCreditCard);

export const useSettingsNav = ({ t }: ReturnType<typeof useI18n>) => {
    try {
        const { hasAnyRoles } = useUser();

        return [
            {
                label: t("navigation.account"),
                items: [
                    {
                        icon: faCogs,
                        label: t("navigation.account"),
                        to: {
                            name: "settings-account",
                        },
                        keep: hasAnyRoles(["owner", "admin"]),
                    },
                    {
                        icon: faMoneyBill,
                        label: t("navigation.billing"),
                        to: {
                            name: "settings-account-billing",
                        },
                        keep: hasAnyRoles(["owner", "billing"]),
                    },
                    {
                        icon: faUser,
                        label: t("navigation.profile"),
                        to: {
                            name: "settings-me-profile",
                        },
                        hideInUserDropdown: true,
                    },
                    {
                        icon: faCreditCard,
                        label: t("navigation.usage"),
                        to: {
                            name: "settings-account-usage",
                        },
                        keep: hasAnyRoles(["owner", "admin"]),
                    },
                ].filter((route) => route.keep === undefined || route.keep),
            },
            {
                label: t("navigation.configuration"),
                items: [
                    {
                        icon: faCommand,
                        label: t("navigation.apps"),
                        to: {
                            name: "settings-apps",
                        },
                        keep: hasAnyRoles(["owner", "admin"]),
                    },
                    {
                        icon: faBuildings,
                        label: t("navigation.brands"),
                        to: {
                            name: "settings-account-brands",
                        },
                        keep: hasAnyRoles(["owner", "admin"]),
                        highlight: ["settings-account-brands-id"],
                    },
                    {
                        icon: faGlobe,
                        label: t("navigation.domains"),
                        to: {
                            name: "settings-account-domains",
                        },
                        keep: hasAnyRoles(["owner", "admin"]),
                        highlight: ["settings-account-domains-id"],
                    },
                    {
                        icon: faEnvelopesBulk,
                        label: t("navigation.emails"),
                        to: {
                            name: "emails",
                        },
                        keep: hasAnyRoles(["owner", "admin"]),
                        hideInUserDropdown: true,
                    },
                    {
                        icon: faPenField,
                        label: t("navigation.forms"),
                        to: {
                            name: "forms",
                        },
                        keep: hasAnyRoles(["owner", "admin"]),
                        hideInUserDropdown: true,
                    },
                    {
                        icon: faMapLocation,
                        label: t("navigation.locations"),
                        to: {
                            name: "settings-account-locations",
                        },
                        keep: hasAnyRoles(["owner", "admin"]),
                        hideInUserDropdown: true,
                    },
                    {
                        icon: faUsers,
                        label: t("navigation.users"),
                        to: {
                            name: "settings-account-users",
                        },
                        keep: hasAnyRoles(["owner", "admin"]),
                    },
                ].filter((route) => route.keep === undefined || route.keep),
            },
            {
                label: t("navigation.communication_preferences"),
                items: [
                    {
                        icon: faBan,
                        label: t("navigation.blacklist"),
                        to: {
                            name: "settings-account-block-list",
                        },
                        keep: hasAnyRoles(["owner", "admin"]),
                        hideInUserDropdown: true,
                    },
                    {
                        icon: faLanguage,
                        label: t("navigation.localization"),
                        to: {
                            name: "settings-account-localization",
                        },
                        keep: hasAnyRoles(["owner", "admin"]),
                        hideInUserDropdown: true,
                    },
                    {
                        icon: faShield,
                        label: t("navigation.safety_limits"),
                        to: {
                            name: "settings-account-safety-limits",
                        },
                        keep: hasAnyRoles(["owner", "admin"]),
                    },
                    {
                        icon: faEnvelope,
                        label: t("navigation.unsubscribes"),
                        to: {
                            name: "settings-account-unsubscribes",
                        },
                        keep: hasAnyRoles(["owner", "admin"]),
                    },
                ].filter((route) => route.keep === undefined || route.keep),
            },
            {
                label: t("navigation.logs"),
                items: [
                    {
                        icon: faBolt,
                        label: t("navigation.events"),
                        to: {
                            name: "settings-events",
                        },
                        keep: hasAnyRoles(["owner", "admin"]),
                    },
                    {
                        icon: faArrowsSpin,
                        label: t("navigation.processes"),
                        to: {
                            name: "settings-runs",
                        },
                        keep: hasAnyRoles(["owner", "admin"]),
                    },
                ].filter((route) => route.keep === undefined || route.keep),
            },
        ].filter((item) => item.items.length > 0);
    } catch (e) {
        console.error(e);
        return [];
    }
};
